<template>
    <div class="secondary-dialog">
        <el-dialog
            :visible.sync="visible"
            :title="activeName === 'member' ? $t('Sell.change_ci') : $t('Sell.change_lesson')"
            left>
            <el-form
                ref="form"
                :model="form"
                label-suffix=":"
                label-width="80px"
                label-position="right">
                <el-form-item
                    :label="activeName === 'member' ? $t('Lesson.purchased_times') : $t('Lesson.purchased_class')">
                    {{ activeName === 'member' ? clientInfo.cardCredit : clientInfo.lessonCredit }}
                     {{ $t('Board.Team.festival') }}
                </el-form-item>
                <el-form-item
                    :label="activeName === 'member' ? $t('Lesson.remaining_times') : $t('Lesson.remaining_class')">
                    {{ activeName === 'member' ? clientInfo.cardBalance : clientInfo.lessonBalance }}
                     {{ $t('Board.Team.festival') }}
                </el-form-item>
                <el-form-item
                    :label="activeName === 'member' ? $t('Sell.change_ci') : $t('Sell.change_lesson')"
                    class="secondary-form-item">
                    <div class="secondary-radio-bg">
                        <el-radio v-model="form.option" label="1">
                            {{ $t('Lesson.increase') }}{{ activeName === 'member' ? $t('Lesson.frequency') : $t('Lesson.class') }}
                            <el-input
                                v-model.number="form.addNum"
                                class="mr-10 ml-10"
                                style="width: 110px;" />
                            {{ activeName === 'member' ? $t('Week.ci') : $t('Board.Team.festival') }}
                        </el-radio>
                        <el-radio v-model="form.option" label="2">
                            {{ $t('Lesson.cut_back') }}{{ activeName === 'member' ? $t('Lesson.frequency') : $t('Lesson.class') }}
                            <el-input
                                v-model.number="form.cutNum"
                                class="mr-10 ml-10"
                                style="width: 110px;" />
                            {{ activeName === 'member' ? $t('Week.ci') : $t('Board.Team.festival') }}
                        </el-radio>
                    </div>
                </el-form-item>
                <el-form-item :label="$t('Common.remark')">
                    <el-input type="textarea" rows="6" v-model="form.remark" />
                </el-form-item>
            </el-form>
            <div class="text-center">
                <el-button
                    @click="submit"
                    type="primary">
                    {{ $t('Message.confirm') }}
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { Dialog, DatePicker, Radio, RadioGroup } from 'element-ui';

export default {
    components: {
        ElDialog: Dialog,
        ElDatePicker: DatePicker,
        ElRadio: Radio,
        ElRadioGroup: RadioGroup,
    },
    props: ['activeName'],
    data() {
        return {
            visible: false,
            contractNum: null,
            clientInfo: {},
            form: {
                count: null,
                option: '1', // 1-增加, 2-减少
                remark: null,
                addNum: null,
                cutNum: null,
            },
            type: null,
        };
    },
    watch: {
        'visible'(val) {
            if (!val) this.resetForm();
        },
    },
    methods: {
        resetForm() {
            this.form = {
                count: null,
                option: '1',
                remark: null,
                addNum: null,
                cutNum: null,
            };
            setTimeout(() => {
                this.$refs.form.resetFields();
            }, 0);
        },
        open(data) {
            this.contractNum = data.contractNum;
            this.getDesc();
            this.fetchData();
        },
        getDesc() {
            if (this.activeName === 'member') this.type = 'mshp';
            else this.type = 'coach';
        },
        fetchData() {
            API.get(`contract/${this.type}/${this.contractNum}`).then(res => {
                if (res.cardTypeCode !== 2 && this.type === 'mshp')
                return $ele.$message(this.$t('Message.ci_modify'));
                this.clientInfo = res;
                this.visible = true;
            });
        },
        submit() {
            const option = Number(this.form.option);
            if (option === 1) this.form.count = this.form.addNum;
            else this.form.count = this.form.cutNum;
            if ((option === 1 && !this.form.addNum) || (option === 2 && !this.form.cutNum)) $ele.$message(this.$t('Message.count_tip'));
            else if ((option === 1 && this.form.addNum) || (option === 2 && this.form.cutNum)) this.postData();
        },
        postData() {
            const form = Object.assign({}, this.form);
            delete form.addNum;
            delete form.cutNum;
            let url;
            if (this.activeName === 'member') url = `contract/${this.type}/${this.contractNum}/card-balance`;
            else url = `contract/${this.type}/${this.contractNum}/lesson-balance`;
            API.post(url, form)
            .then(() => {
                $ele.$message.success(this.$t('Message.success'));
                this.visible = false;
                this.$emit('fetchData');
            });
        },
    },
};
</script>
<style lang="scss">
.secondary-dialog {
    .el-dialog {
        width: 710px;
    }
}
.secondary-form-item {
    .el-form-item__label {
        width: 100% !important;
        text-align: left !important;
    }
    .el-radio {
        width: 70%;
        margin-left: 0 !important;
        margin-bottom: 10px;

        &:last-child {
            margin-bottom: 0;
        }
    }
    .el-radio__label {
        font-size: 12px !important;
    }
    .el-form-item__content {
        margin-left: 0 !important;
    }
}
.secondary-radio-bg {
    background: #f7f7f7;
    padding: 15px 40px;
    margin-top: 50px;
}
</style>
